<template>
	<div
		style="padding-top: 5px; padding-left: 10px; padding-right: 10px; padding-bottom: 15px; flex: 1; display: flex">
		<vue2-tinymce-editor :options="tinymceConfig" v-model="content" class="sa-tinymce"></vue2-tinymce-editor>
	</div>
</template>

<script>
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
export default {
	components: { Vue2TinymceEditor },
	data() {
		return {
			content: "",
			tinymceConfig: {
				skin: false,
				content_css: false,
				icons: "default",
				menubar: true,
				branding: true,
				plugins: "lists table image code",
				toolbar: "undo redo | alignleft aligncenter alignright alignjustify | table image | KBox KHeader | bold italic underline strikethrough forecolor backcolor | bullist numlist | removeformat | code",
				extended_valid_elements: "*[*]",
				custom_elements: "header,footer",

				// Permette di scegliere un'immagine dal PC dal dialog nativo "image"
				// (icona immagine in toolbar) e la incorpora in base64 nel contenuto,
				// senza bisogno di un endpoint di upload lato backend.
				file_picker_types: "image",
				file_picker_callback: function (callback, value, meta) {
					if (meta.filetype !== "image") {
						return;
					}
					const input = document.createElement("input");
					input.setAttribute("type", "file");
					input.setAttribute("accept", "image/*");
					input.onchange = function () {
						const file = this.files[0];
						if (!file) {
							return;
						}
						const reader = new FileReader();
						reader.onload = function () {
							callback(reader.result, { alt: file.name });
						};
						reader.readAsDataURL(file);
					};
					input.click();
				},

				forced_root_block: "div",
				remove_trailing_brs: false,
				entity_encoding: "raw",

				content_style: `
    body { font-family: Arial, sans-serif; font-size: 14px; }
    .ft-checkbox-box { display: flex; margin: 10px 0; cursor: pointer; max-width:'max-content' }
    .ft-checkbox-box .ft-checkbox { display: inline-block; width: 15px; height: 15px; border: 2px solid #333; margin-right: 8px; vertical-align: middle; background-color: #fff; }
    .ft-checkbox-box[data-checked="true"] .ft-checkbox { background-color: #007bff; }
    .ft-header-block { border-bottom: 2px solid #007bff; padding-bottom: 10px; margin-bottom: 15px; font-weight: bold; font-size: 16px; color: #333; }
  `,
				theme: "silver",
				setup(editor) {
					// Pulsante personalizzato Checklist
					editor.ui.registry.addButton("KBox", {
						text: "KBox",
						tooltip: "Inserisci una checkbox",
						onAction: () => {
							const boxHtml = `
                            <div class="ft-checkbox-box" data-checked="false">
                                <span class="ft-checkbox"></span>
                                <span class="ft-checkbox-label">text</span>
                            </div>
                            `;
							editor.insertContent(boxHtml);
						},
					});

					// Pulsante personalizzato Testata (Header) con immagine e intestazione
					editor.ui.registry.addButton("KHeader", {
						text: "Testata",
						tooltip: "Inserisci una testata con logo e intestazione",
						onAction: () => {
							const origin = typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : '';
							const baseUrl = typeof process !== 'undefined' && process.env && process.env.BASE_URL ? process.env.BASE_URL : '/';
							let defaultLogo = baseUrl;
							if (!defaultLogo.startsWith('http')) {
								defaultLogo = origin + (defaultLogo.startsWith('/') ? '' : '/') + defaultLogo;
							}
							if (!defaultLogo.endsWith('/')) {
								defaultLogo += '/';
							}
							defaultLogo += 'img/logo.png';
							const headerHtml = `
                            <div class="ft-header-block" style="display: flex; align-items: center; justify-content: space-between; border-bottom: 2px solid #007bff; padding-bottom: 10px; margin-bottom: 15px;">
                                <div style="display: flex; align-items: center; gap: 15px;">
                                    <img src="${defaultLogo}" alt="Logo" style="max-height: 50px; width: auto;" />
                                    <div>
                                        <strong style="font-size: 16px; color: #333;">NOME STRUTTURA SANITARIA</strong><br/>
                                        <span style="font-size: 12px; color: #666;">Indirizzo, Telefono, P.IVA / C.F.</span>
                                    </div>
                                </div>
                                <div style="text-align: right; font-size: 12px; color: #444;">
                                    <strong>MODULO DI CONSENSO INFORMATO</strong>
                                </div>
                            </div>
                            `;
							editor.insertContent(headerHtml);
						},
					});

					editor.on("click", function (e) {
						const box = e.target.closest(".ft-checkbox-box");
						if (!box) return;
						e.stopPropagation();
						const isLabelClick = e.target.classList.contains("ft-checkbox-label") || e.target.classList.contains("ft-checkbox");
						if (isLabelClick) {
							const checked = box.getAttribute("data-checked") === "true";
							box.setAttribute("data-checked", !checked);
						}
					});

					editor.on("dragover", function (e) {
						e.preventDefault();
						editor.focus();
					});

					editor.on("drop", function (e) {
						e.preventDefault();
						editor.focus();
						let data = e.dataTransfer.getData("text/html");
						if (data) {
							editor.insertContent(data);
							editor.nodeChanged();
							editor.focus();
						}
					});
				},
			},
		};
	},
	watch: {
		content() {
			this.$emit("updateContent", this.content);
		},
	},
	methods: {
		setContent(textContent) {
			this.content = textContent;
		},
	},
};
</script>

<style></style>